var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"modal-trigger-button",on:{"click":function($event){$event.preventDefault();return _vm.openPopup.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('hose.searchBuild'))+" ")]),(_vm.showPopup)?_c('LoadBuildModal',{on:{"close":_vm.closePopup}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }